// extracted by mini-css-extract-plugin
module.exports = {"root":"az_c8c","ratingRadioButton":"az_d8c","ratingItemIcon":"az_e8c","empty":"az_f8c","a11label":"az_g8c"};